import { render, staticRenderFns } from "./ProductEditLabel.vue?vue&type=template&id=2cd748c8&"
import script from "./ProductEditLabel.vue?vue&type=script&lang=js&"
export * from "./ProductEditLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports